import * as firebaseNative from 'firebase/analytics';
import { withInstance } from '../../helpers';

export function log(...params) {
  return withInstance((analytics) => firebaseNative.logEvent(analytics, ...params));
}
